export enum FadeDirection {
  LEFT = 'left',
  RIGHT = 'right',
  FULL = 'full',
}

export const SCROLLABLE_FADE_CONFIG = {
  FADE_WIDTH: '16px',
  DEFAULT_FADE_COLOR: 'rgb(var(--background-neutral-primary))',
} as const;
